// eslint-disable-next-line
export class ModuleConfigurationRequest {
    ConfigurationId: Number;
    ConfigurationKeyId: Number;
    ConfigurationValue: string;
    Agent: string;
    Dataset: string;
    constructor() {
      this.ConfigurationId = 0;
      this.ConfigurationKeyId = 0;
      this.ConfigurationValue = '';
      this.Agent = '';
      this.Dataset = '';
    }
}
